module.exports = __webpack_public_path__ + "img/stay-tuned.2c4fa670.svg";